'use strict';

// Smooth scrolling links
{
  const smoothScrolllingLinks = {
    el: {
      links: document.querySelectorAll('.js_link')
    },

    init() {
      this.clickHandler();
    },

    clickHandler() {
      this.el.links.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.goTo(link);
          return 0;
        });
      });
    },

    goTo(link) {
      // Target ID
      const linkID = link.getAttribute('href');
      console.log(linkID);

      // Use Jump.js
      Jump(linkID, {
        duration: 800,
        //offset: -headerHeight,
        a11y: false,
        //easing: easeInOutQuad,
        //callback: () => console.log('jump completed'),
      });
    }
  }

  if (document.querySelector('.js_link')) {
    smoothScrolllingLinks.init();
  }
}

// Hero slider
{
  const heroSlider = {
    el: {
      sliderEl: document.querySelector('.js_hero-slider')
    },

    init() {
      this.runSlider();
    },

    runSlider() {
      const glide = new Glide(this.el.sliderEl, {
        type: 'carousel',
        perView: 1,
        focusAt: 'center',
        gap: 0,
        animationDuration: 1200,
        autoplay: 5000,
        hoverpause: false,
        animationTimingFunc: 'ease',
        keyboard: true,
        breakpoints: {
          767: {
            perView: 1
          }
        }
      });

      glide.mount();
    }
  };

  if (document.querySelector('.js_hero-slider')) {
    heroSlider.init();
  }
}

// Hamburger menu
{
  const hbMenu = {
    el: {
      headerLogoEl: document.querySelector('.nav-sp__logo'),
      menuEl: document.querySelector('.js_nav-sp'),
      openBtnEl: document.querySelector('.js_nav-sp-open'),
      closeBtnEl: document.querySelector('.js_nav-sp-close'),
      navLinkEls: document.querySelectorAll('.js_nav-sp .js_link')
    },

    init() {
      this.openHandler();
      this.closeHandler();
      this.linkHandler();
    },

    openHandler() {
      this.el.openBtnEl.addEventListener('click', (event) => {
        event.preventDefault();
        this.openMenu();
        return 0;
      });
    },

    closeHandler() {
      this.el.closeBtnEl.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeMenu();
        return 0;
      });
    },

    openMenu() {
      this.el.menuEl.classList.add('active');
      this.el.headerLogoEl.classList.add('inactive');
    },

    closeMenu() {
      this.el.menuEl.classList.remove('active');
      this.el.headerLogoEl.classList.remove('inactive');
    },

    linkHandler() {
      this.el.navLinkEls.forEach((navLink) => {
        navLink.addEventListener('click', (event) => {
          this.closeMenu();
        });
      });
    }
  };

  if (document.querySelector('.js_nav-sp')) {
    hbMenu.init();
  }
}

// Tabbed/accordion content section
{
  const tabbedContent = {
    el: {
      accordionBtnEls: document.querySelectorAll('.js_acr-tab'),
      accordionBtnClass: '.js_acr-tab',
      accordionSectionClass: '.js_acr-content'
    },

    init() {
      this.clickHandler();
    },

    clickHandler() {
      const _this = this;

      this.el.accordionBtnEls.forEach((btnEl) => {
        btnEl.addEventListener('click', (event) => {
          event.preventDefault();

          _this.openContent(btnEl);

          return 0;
        });
      });
    },

    openContent(btnEl) {
      const currentAcr = btnEl.closest('.js_acr');
      const contentID = btnEl.getAttribute('href');
      const content = currentAcr.querySelector(contentID);

      this.closeContent(currentAcr);

      btnEl.classList.add('active');
      content.classList.add('active');
    },

    closeContent(currentAcr) {
      const accordionBtnEls = currentAcr.querySelectorAll(this.el.accordionBtnClass);
      const accordionSectionEls = currentAcr.querySelectorAll(this.el.accordionSectionClass);

      accordionBtnEls.forEach((btnEl) => {
        btnEl.classList.remove('active');
      });
      accordionSectionEls.forEach((sectionEl) => {
        sectionEl.classList.remove('active');
      });
    }
  };

  if (document.querySelector('.js_acr')) {
    tabbedContent.init();
  }
}

// Go to top button
{
  const goToBtn = {
    el: {
      buttons: document.querySelectorAll('.js_goto-link')
    },

    conf: {
      startOffset: 10
    },

    init() {
      this.scrollHandler();
    },

    scrollHandler() {
      const _this = this;

      addEventListener('scroll', () => {
        const scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
        const triggerPosition = document.getElementById('showGoToBtn').getBoundingClientRect().top + scrollPos - 20;

        // Show the button if it is passed the trigger position
        if (scrollPos > triggerPosition) {
          _this.showButton();
        } else {
          _this.hideButton();
        }
      });
    },

    showButton() {
      this.el.buttons.forEach((button) => {
        button.classList.add('active');
      });
    },

    hideButton() {
      this.el.buttons.forEach((button) => {
        button.classList.remove('active');
      });
    }
  };

  if (document.querySelector('.js_goto-link')) {
    goToBtn.init();
  }
}